export class AgreementsApiConstants {
  public static readonly getApplicationAgreement: string =
    '/applications/agreements/get';
  public static readonly setApplicationAgreement: string =
    '/applications/agreements/set';
  public static readonly getContractAgreement: string = '/contracts/documents';
  public static readonly setContractAgreement: string = '/contracts/sign';
}
